import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo, useContext } from 'preact/compat';
import { useFormContext, } from 'react-hook-form';
import { format, parse } from 'date-fns';
import { ThemeContext } from 'styled-components';
import { getActivities, getSelectedActivities, resetFetchedAll, } from '@genericBookings/store/reducers/activities';
import FormStep from '@genericBookings/components/FormStep';
import IndepthDatepicker from '@genericBookings/components/IndepthDatepicker';
import { useStepCompletion } from '@widgets/DayTickets/context/Steps';
import { useAppDispatch, useAppSelector } from '@genericBookings/store/hooks';
import { useMessage } from '@genericBookings/context/Message';
import visitDateEvent from '@genericBookings/primaryActionEvents';
import { useTimeConflict } from '@bookingForm/context/TimeConflicts';
import { numberArrayToVisitors, visitorCount } from '@genericBookings/visitorUtils';
import API from '@widgets/shared/API/connection';
import { useFieldsWrapper } from '@genericBookings/context/FieldsWrapper';
import useSessionRefresh from '@genericBookings/hooks/useSessionRefresh';
import { Wrapper } from './styled';
const DEFAULT_SELECTED_DATE_FORMAT = 'iii do MMM yyyy';
function CalendarFormStep(props) {
    const { productId, options, children, visitDateEventCallback, half, isWide, step } = props;
    const { isLastStep, resetStepsCompleted, modifyStep, sessionStep } = useStepCompletion();
    const { datepickerOpen, setDatepickerOpen } = useFieldsWrapper();
    const { getValues, setValue } = useFormContext();
    const date = getValues('VisitDate');
    const visitors = numberArrayToVisitors(Array(9)
        .fill(0)
        .map((_, idx) => getValues(`Visitors${idx}`)));
    const { errors } = useMessage();
    const { isBuilder, isMulti, debug, themeName } = useContext(options);
    const { selectedDateFormat } = useContext(ThemeContext);
    const dispatch = useAppDispatch();
    const activitiesSelector = isBuilder ? getSelectedActivities : getActivities;
    const activities = useAppSelector(activitiesSelector);
    const shouldUseIndepthDatePicker = useMemo(() => isLastStep && (activities.some(({ sessions }) => sessions.length === 0) || errors.length !== 0), [activities, errors.length, isLastStep]);
    const { initTimePeriods } = useTimeConflict();
    const canUseIndepthDatepicker = useMemo(() => date && visitorCount(visitors) > 0, [date, visitors]);
    const resetSessions = useSessionRefresh(options);
    // TODO: IndepthDatepicker probably needs relooking at as not updating in this iteration as not required.
    return (_jsxs(Wrapper, { half: half, isWide: isWide, children: [_jsx(FormStep, { ...props, onHandleClick: () => {
                    if (shouldUseIndepthDatePicker) {
                        setDatepickerOpen(!datepickerOpen);
                    }
                    else {
                        setValue('VisitDate', '');
                        resetStepsCompleted();
                        setTimeout(() => {
                            visitDateEvent(false, visitDateEventCallback);
                        }, 1);
                        dispatch(resetFetchedAll());
                        resetSessions().then(() => { });
                        modifyStep(step, false);
                    }
                }, onHandleFormat: (value) => {
                    if (!value)
                        return '';
                    return format(parse(`${value}`, 'yyyy-MM-dd', new Date()), selectedDateFormat ?? DEFAULT_SELECTED_DATE_FORMAT);
                }, half: false, isWide: false, children: children }), datepickerOpen && (_jsx(IndepthDatepicker, { productId: productId, options: options, endpoint: isMulti ? API.hasDaySessions : API.hasSessions, sessionStep: sessionStep, shouldCheck: true, selectedDate: date ? new Date(Date.parse(date)) : new Date() }))] }));
}
CalendarFormStep.defaultProps = {
    visitDateEventCallback: undefined,
    completedLabel: undefined,
};
export default CalendarFormStep;
